export const ROUTE_ORDER_BOOK = '/editor/order/:orderId';

export const ROUTE_EDIT_DRAFT = '/editor/draft/:draftId';
export const ROUTE_EDIT_DRAFT_COVER = `${ROUTE_EDIT_DRAFT}`;
export const ROUTE_EDIT_DRAFT_MANAGE_SECTIONS = `${ROUTE_EDIT_DRAFT}/manage`;
export const ROUTE_EDIT_DRAFT_CONTENT = `${ROUTE_EDIT_DRAFT}/content`;
export const ROUTE_EDIT_DRAFT_CONTENT_SECTION = `${ROUTE_EDIT_DRAFT_CONTENT}/:sectionId`;
